import { Link } from "react-router-dom";
import { JandiLogo } from "../../assets/logos/svgs";

const SidebarHeader = () => {
  return (
    <div className="pro-header">
      <Link to="/">
        <JandiLogo style={{ width: "75%" }} />
      </Link>
      {/* End logo */}

      <div className="fix-icon" data-bs-dismiss="offcanvas" aria-label="Close">
        <span
          className="flaticon-close-1"
          style={{ fontSize: 18, color: "black", marginRight: 10 }}
        ></span>
      </div>
      {/* icon close */}
    </div>
  );
};

export default SidebarHeader;
